module.exports = __webpack_public_path__ + "img/vehicle-maintenance-log-book_B09KNCWQ8Q.7c48eae1.jpg";